<template>
  <div class="container-fluid mt-6">
    <div id="lower-div" class="row mt-3">
      <div class="card mb-4">
        <div v-loading="loading">
          <div class="p-2" m="4">
            <div class="card-body px-0 pt-0 pb-3">
              <titles text="Təsdiq gözləyən işlər"></titles>
              <hr style="margin-top:0;margin-bottom: 15px;" />
              <subrogation-table :loading="loading" :data="data"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Titles from "@/project/Components/Titles.vue";
import SubrogationTable from "@/project/NewSubrogationCases/Components/Tables/Table.vue";
import { subrogationData } from "@/project/Source/helper";

export default {
  components: {
    Titles,
    SubrogationTable
  },
  data() {
    return {
      loading: false,
      data: [],
      search: ''
    };
  },
  mounted() {
    this.fetchSubrogations();
  },
  methods: {
    fetchSubrogations() {
      this.loading = true;
      this.data = subrogationData;
      this.loading = false;
    }
  },
};
</script>